// Lakai — related-products loader for sections/p7-product-related.liquid.
// Section-rendering pattern, no Dawn <product-recommendations> element:
// each [data-p7-recommendations] section carries its own prebuilt URL
// (routes.product_recommendations_url + section_id + product_id + limit).
// We fetch it, parse the server-rendered HTML, and swap the inner markup in.
// The section ships with the `hidden` attribute and is only revealed when
// Shopify actually returns recommendations — no layout reserved, no flash.
(function () {
  'use strict';
  if (window.__p7RecommendationsInit) return;
  window.__p7RecommendationsInit = true;

  function hydrate(sectionEl) {
    if (sectionEl.dataset.p7RecsLoaded === 'true') return;
    sectionEl.dataset.p7RecsLoaded = 'true';

    var url = sectionEl.getAttribute('data-url');
    if (!url || !window.fetch) return;

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('p7-recommendations: HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-p7-recommendations-content]');
        var target = sectionEl.querySelector('[data-p7-recommendations-content]');
        if (!fresh || !target) return;
        // Empty response body means Shopify had nothing to recommend, and a
        // card-less grid means every recommendation was filtered out (e.g.
        // "hide merged parent products") — leave the section hidden rather
        // than showing a bare heading either way.
        if (!fresh.children.length) return;
        // The rail renders the unified card (snippets/p7-card.liquid).
        if (!fresh.querySelector('.p7-related-products__grid [data-card]')) return;
        // Move the parsed nodes across rather than assigning innerHTML:
        // same-origin markup rendered by our own Liquid, and nodes parsed
        // by DOMParser keep their scripts inert when adopted.
        while (target.firstChild) target.removeChild(target.firstChild);
        while (fresh.firstChild) target.appendChild(fresh.firstChild);
        sectionEl.hidden = false;
      })
      .catch(function () {
        // Network/parse failure: recommendations are decorative — stay hidden.
      });
  }

  function init() {
    var sections = document.querySelectorAll('[data-p7-recommendations]');
    Array.prototype.forEach.call(sections, hydrate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
